import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { Typography, Paper, Tooltip } from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import ModalFrame from "../../biztran_controls/Modal_Frame";
import AddProduct from "./AddProduct";
import EditProduct from "./EditProduct";

const DCDtlsView = (props) => {

  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);
  const [isEditOpen, setEditOpen] = useState(false);
  const [DCID, setDCID] = useState("");
  const [DeliveryChallanDtlsID, setDeliveryChallanDtlsID] = useState("");
  const [AccountID, setAccountID] = useState("");
  const [SalesOrderNo, setSalesOrderNo] = useState("");
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [TotalAmount, setTotalAmount] = useState("");
  const [GSTAmount, setGSTAmount] = useState("");
  const [Description, setDescription] = useState("");
  const [CreatedBy, setCreatedBy] = useState("");
  const [CreatedOn, setCreatedOn] = useState("");
  const [ModifiedBy, setModifiedBy] = useState("");
  const [Delivery, setDelivery] = useState("");
  const [IncoTerms, setIncoTerms] = useState("");
  const [Origin, setOrigin] = useState("");
  const [Warranty, setWarranty] = useState("");
  const [Weight, setWeight] = useState("");
  const [BoxSize, setBoxSize] = useState("");
  const [ModifiedOn, setModifiedOn] = useState("");

  const handleOpenModal = (row) => {
    // debugger;
    setEditOpen(true);
    setDCID(props.DeliveryChallanID);
    //setEditQTTID(props.EditQTID);
    setDeliveryChallanDtlsID(row.id);
  };

  const OpenModal = () => {
    // debugger;
    setOpen(true);
    setDCID(props.DeliveryChallanID);
    setAccountID(props.DCMainData[0].AccountID);
    setSalesOrderNo(props.DCMainData[0].SalesOrderNo);
    setDeliveryChallanDtlsID("");
  };

  useEffect(() => {
    if (props.DCMainData !== undefined && props.DCMainData.length > 0) {
      setTotalAmount(props.DCMainData[0].TotalAmount);
      setGSTAmount(props.DCMainData[0].GstAmount);
      setDescription(props.DCMainData[0].Description);
      setCreatedBy(props.DCMainData[0].CreatedBy);
      setCreatedOn(props.DCMainData[0].CreatedOn);
      setModifiedBy(props.DCMainData[0].ModifiedBy);
      setModifiedOn(props.DCMainData[0].ModifiedOn);
      setDelivery(props.DCMainData[0].Delivery);
      setIncoTerms(props.DCMainData[0].IncoTerms);
      setOrigin(props.DCMainData[0].Origin);
      setWarranty(props.DCMainData[0].Warranty);
      setWeight(props.DCMainData[0].Weight);
      setBoxSize(props.DCMainData[0].BoxSize);
    }
  }, [props.DCMainData]);



  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) => (
          <strong>
            {" "}
            <a
              href="javascript:;"
              onClick={() => {
                handleOpenModal(params);
              }}
            >
              <EditIcon fontSize="small" />
            </a>{" "}
          </strong>
        ),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 34,
      },
      {
        field: "Seq",
        headerName: ".",
        type: 'number',
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 34,
      },
      {
        field: "ModelCode",
        headerName: "Model",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "ProductName",
        headerName: "Product",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "PDescription",
        headerName: "Product Description",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 220,
      },
      {
        field: "Quantity",
        headerName: "DCQuantity",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 170,
      },
      {
        field: "Rate",
        headerName: "Rate",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 140,
      },
      {
        field: "RateINR",
        headerName: "RateINR",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "CgstPer",
        headerName: "Cgst%",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 140,
      },
      {
        field: "SgstPer",
        headerName: "Sgst%",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 140,
      },
      {
        field: "IgstPer",
        headerName: "Igst%",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 140,
      },

    ];
    setColumns(gridCols);
    // debugger;
    if (props.DCDtlsData != null && props.DCDtlsData != undefined && props.DCDtlsData.length > 0) {
      setRows(props.DCDtlsData);
    }
    else {
      setRows([]);
    }
  }, [props.DCDtlsData]);


  return <Paper style={{ paddingLeft: 10, paddingRight: 10 }}>
    <h2 style={{ textDecoration: "underline", textDecorationColor: "#0096FF", textDecorationThickness: 5, }}>
      DETAILS
    </h2>
    <Typography className={classes.headerCmn} noWrap>
      Product Details
      <div style={{ width: "100%" }}>
        <div style={{ float: "right" }}>
          <BiztranControls.Button
            text="Add Product"
            style={{ margin: "0.2rem", height: "1.6rem" }}
            startIcon={<AddCircleOutlineIcon />}
            onClick={() => {
              OpenModal();
            }}
          />
        </div>
      </div>
    </Typography>
    <Grid spacing={1} container style={{ marginTop: 7, paddingRight: 10 }}>
      <BiztranControls.DataGrid
        rowHeight={25}
        rows={rows}
        columns={columns}
        checkboxSelection={false}
        Height="340px"
        Width="100%"
      />
      <ModalFrame
        title="Add Product"
        maxWidth="lg"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <AddProduct
          DCID={DCID}
          DeliveryChallanDtlsID={DeliveryChallanDtlsID}
          AccountID={AccountID}
          SalesOrderNo={SalesOrderNo}
          setOpen={setOpen}
          getByIDData={props.PopulateData}
        />
      </ModalFrame>
      <ModalFrame
        title="Edit Product"
        maxWidth="md"
        isOpen={isEditOpen}
        setOpen={setEditOpen}
      >
        <EditProduct
          DCID={DCID}
          DeliveryChallanDtlsID={DeliveryChallanDtlsID}
          setOpen={setEditOpen}
          getByIDData={props.PopulateData}
        />
      </ModalFrame>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Description:</h5>
        <h5>{Description}</h5>
      </Grid>
      <Grid item xs={12} className={classes.headerCmn}>
        Terms & Conditions
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Delivery:</h5>
        <h5>{Delivery}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Inco Terms:</h5>
        <h5>{IncoTerms}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Origin:</h5>
        <h5>{Origin}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Warranty:</h5>
        <h5>{Warranty}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Weight:</h5>
        <h5>{Weight}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>BoxSize:</h5>
        <h5>{BoxSize}</h5>
      </Grid>
      <Grid item xs={12} className={classes.headerCmn}>
        System Information
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Created By:</h5>
        <h5>{CreatedBy}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Last Modified By:</h5>
        <h5>{ModifiedBy}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Created On:</h5>
        <h5>{CreatedOn}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Modified On:</h5>
        <h5>{ModifiedOn}</h5>
      </Grid>
    </Grid>
  </Paper>;
};

const useStyles = makeStyles((theme) => ({
  header: {
    width: "100%",
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "1.7rem",
    fontSize: "1.8rem",
    display: "flex",
    flexDirection: "row",
  },
  headertext:
  {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    display: "flex",
    flexDirection: "row",
    //   borderRadius: "1rem",
  },
  headerCmn: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    fontSize: "1rem",
    display: "flex",
    flexDirection: "row",
    //margin: "0.3rem",
    fontWeight: "bold",
  },
}));


export default DCDtlsView;
